import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { formatMoney, getTagValue, getFurnitureImage } from '../../functions';
import { addItem, updateItem } from '../../redux/cart/actions';
import IconMinus from '../icons/IconMinus';
import IconPlus from '../icons/IconPlus';

class CartRhsItem extends Component {
  handleClickSubtract(e, lineItem) {
    const { updateItem } = this.props;
    e.preventDefault();
    updateItem(lineItem.key, Number(lineItem.quantity) - 1);
  }

  handleClickAdd(e, lineItem) {
    const { updateItem } = this.props;
    e.preventDefault();
    updateItem(lineItem.key, Number(lineItem.quantity) + 1);
    // this.props.addItem(lineItem.key, 1);
  }

  render() {
    const { item, isLoading } = this.props;
    const title = item.type === 'Furniture'
      ? `${getTagValue(item.tags, 'range')} ${getTagValue(item.tags, 'size')} ${item.title}`
      : item.title;
    const imgSrc = item.type === 'Furniture' && item.properties && item.properties.length
      ? getFurnitureImage(
        item.title,
        item.properties.map((property) => ({
          color: property[1].split('-')[1] && property[1].split('-')[1].trim(),
          material: property[1].split('-')[1] && property[1].split('-')[0].trim(),
        })),
        '180x',
      )
      : item.image;
    const imgSrcset = item.type === 'Furniture' ? null : item.imgSrcset;

    let newInfo = item.info;

    if (item.measurements) {
      const measurementSystem = window.getMeasurementSystem();
      const measurements = item.measurements ? item.measurements[measurementSystem] : '';

      if (measurements && measurements.includes(':')) {
        let isTitleReplaced = false;

        measurements
          .split(',')
          .forEach((measurementItem) => {
            if (isTitleReplaced) return;

            const keyValuePair = measurementItem.split(':');
            if (keyValuePair[1] && keyValuePair[1].toLowerCase() !== 'null' && keyValuePair[1].toLowerCase() !== 'n/a' && keyValuePair[0] !== keyValuePair[1]) {
              if (keyValuePair[0].includes(' x ')) {
                newInfo = newInfo.replaceAll(keyValuePair[0], keyValuePair[1]);
              } else {
                newInfo = newInfo.replaceAll(keyValuePair[0], measurementItem.replace(':', ' '));
              }

              if (newInfo !== item.info) {
                isTitleReplaced = true;
              }
            }
          });
      } else if (measurements && item.info) {
        // Replace 'size' option value
        newInfo = item.info
          .split(' / ')
          .map((infoItem, infoIndex) => (infoIndex === 1 ? measurements : infoItem))
          .join(' / ');
      }
    }

    return (
      <li className="cart-rhs__item">
        <a href={item.url} className="cart-rhs__item-content">
          <div className="cart-rhs__image">
            <img
              className="cart-rhs__img bg-grey"
              src={imgSrc}
              srcSet={imgSrcset}
              sizes="90px"
              alt={title}
            />
          </div>
          <div className="cart-rhs__text">
            <h3 className="p mb-0">{title}</h3>
            {console.log('item.properties', item.properties)}
            {item.type !== 'Furniture' && <p className="p mb-0 color-subtle">{newInfo}</p>}
            {item.type === 'Furniture'
              && item.properties
              && item.optionsWithValues.length
              && item.properties.filter((property) => property[0].charAt(0) !== '_').map((property) => (
                <p className="color-subtle cart__property" key={property[0]}>
                  <span className="cart__option">{property[0]}</span>
                  <span>{property[1].replace('-', '/')}</span>
                </p>
              ))}
            {item.type !== 'Furniture'
              && item.properties
              && item.optionsWithValues && item.optionsWithValues.length
              && item.properties.filter((property) => property[0].charAt(0) !== '_').map((property, index) => (
                <p className={index === (item.properties.length - 1) ? 'color-subtle cart__property mb-2' : `color-subtle cart__property${property[0].includes('__') ? ' property-giftnote' : ''}`} key={property[0]}>
                  <span className="cart__option">
                    {item.type === 'giftnote_giftcard'
                      ? property[0].replace('__', '').replace('giftcard_', '').charAt(0).toUpperCase()
                      + property[0].replace('__', '').replace('giftcard_', '').substring(1)
                      : property[0]}
                  </span>
                  <span>{property[1].replace('-', '/')}</span>
                </p>
              ))}

            <p className={item.type === 'giftnote_giftcard' || item.type === 'Gift Cards' ? 'd-none' : 'mb-0'}>
              {item.quantity}
              <button
                onClick={(e) => this.handleClickSubtract(e, item)}
                disabled={isLoading}
                className="cart-rhs__qty-button"
                type="button"
              >
                <IconMinus />
              </button>
              <button
                onClick={(e) => this.handleClickAdd(e, item)}
                disabled={isLoading}
                className="cart-rhs__qty-button"
                type="button"
              >
                <IconPlus />
              </button>
            </p>
          </div>
          <p className="cart-rhs__price">
            <span
              className="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_total"
              data-item-key={item.key}
              style={{ display: 'none !important' }}
            />
            {Shopify.currency.active + " " + formatMoney(item.itemPriceCents * item.quantity)}
          </p>
        </a>
        {item.error && <p className="mb-0 error">{item.error}</p>}
      </li>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
});

const mapDispatchToProps = {
  addItem,
  updateItem,
};

CartRhsItem.propTypes = {
  item: PropTypes.shape({
    optionsWithValues: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
    key: PropTypes.string,
    url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    variantName: PropTypes.string,
    variantId: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    properties: PropTypes.arrayOf(PropTypes.array),
    image: PropTypes.string,
    imgSrcset: PropTypes.string,
    info: PropTypes.string,
    itemPriceCents: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    measurements: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(PropTypes.any),
    ]),
  }).isRequired,
  updateItem: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartRhsItem);
